
(function collapsableMenuModuleDefinition() {

    angular.module('CollapsableMenu', ['pascalprecht.translate', 'Config']);

})();